import React from 'react';
import './Footer.css';
import logo from '../../Images/Logo_Invis.png';

function Footer() {
  return (
    <footer className="site-footer">
      {/* Regular Footer */}
      <div className="newsletter">
        <h2>Subscribe to our Newsletter</h2>
        <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
          <input
            type="email"
            placeholder="Email address"
            aria-label="Email address"
            required
          />
          <button type="submit">Subscribe</button>
        </form>
      </div>

      {/* Regular footer */}
      <div className="footer-nav">
        <a href="/services">Our Services In Antigua</a>
        {/* <a href="/destinations">Destinations & Itineraries</a> */}
        {/* <a href="/services/destination-itineraries-caribbean-support">Destinations & Itineraries</a> */}
        <a href="/destinations-and-itineraries">Destinations & Itineraries</a>


        <a href="/connect">Connect With Services</a>
      </div>
      <hr />
      <div className="footer-bottom">
        <div className="footer-contact">
          <h4>Get In Touch</h4>
          <p>Feel free to <a href="/contact">Contact Us</a>.</p>
        </div>
        <a href="/">
          <img src={logo} alt="Captain’s Connections Logo" className="footer-logo-image" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
